import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Label } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

class Avanzar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            solicitud_id: null,
            proyecto_codigo: "",
            divideEnEtapas: false,
            etapas: 0,
            certificacionUnica: true,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    getData(){
        const { solicitud_id, etapas, certificacionUnica } = this.state;
        return {solicitud_id, etapas, certificacionUnica}
    }

    setSelects(data) {
        this.setState({
            solicitud_id: data.solicitud_id,
            proyecto_codigo: data.solicitud_codigo,
        });
    }

    resetState() {
        this.setState({
            solicitud_id: null,
            proyecto_codigo: "",
            etapas: 0,
            certificacionUnica: true,
        })
    }

    render() {
        const { etapas, certificacionUnica, divideEnEtapas } = this.state;
        return (
            <ParadigmaModal
                getUrl={api.proyectos.plandetrabajo.avanzar}
                postUrl={api.proyectos.plandetrabajo.avanzar}
                onSubmit={() => this.props.onSubmit()}
                onPreSubmit={() => this.getData()}
                id={this.props.id}
                successMessage={"El Plan de Trabajo generó el Presupuesto con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                notAllowedMessage={"El Plan de Trabajo ya generó el Presupuesto."}
                title={"Generar Presupuesto"}
                buttonTitle={"Generar Presupuesto"}
                buttonIcon={"fa fa-usd fa-lg"}
                className={"ui-modal-dialog ui-modal-md"}
                onClose={() => this.resetState()}
                saveButton={true}
                closeButton={true}
                buttonClass={"btn-success btn-next"}
                onGotData={(data) => this.setSelects(data)}>
                <div className="ui-form">
                    <p className="ui-section-label">Datos del presupuesto</p>
                    <div className="ui-row-1">
                        <div className="ui-field">
                            <Label>Nº Presupuesto</Label>
                            <ParadigmaAsyncSeeker pkField={"codigo"} nombreField={"cod"} fieldName={""}
                                url={api.proyectos.solicitudes.selectcodigo} value={this.state.proyecto_codigo} disabled={true} />
                        </div>
                    </div>
                    <div className="ui-row-1">
                        <div className="ui-field">
                            <Label>Proyecto</Label>
                            <ParadigmaAsyncSeeker fieldName={"solicitud_id"} url={api.proyectos.solicitudes.select}
                                value={this.state.solicitud_id} disabled={true} />
                        </div>
                    </div>
                </div>

                {/*<ParadigmaLabeledInput
                    label={"Pptos en etapas"}
                    labelColumns={3}
                    fieldColumns={2}
                    inputComponent={<input className="mt-2" checked={divideEnEtapas} onChange={(e) => this.setState({ divideEnEtapas: !divideEnEtapas, etapas:0, certificacionUnica:true })} type="checkbox" name="certificacionUnica"></input>}
                />
            
                {divideEnEtapas==true &&
                <Fragment>

                    <ParadigmaLabeledInput
                        label={"Etapas"}
                        labelColumns={3}
                        fieldColumns={2}
                        inputComponent={<Input
                            type={"integer"}
                            value={etapas}
                            maxLength={3}
                            onChange={(e)=>this.setState({etapas: e.target.value})}
                            onFocus={(event) => event.target.select()}
                        />}
                    />
                           
                    <ParadigmaLabeledInput
                        label={"Unica certificación"}
                        labelColumns={'auto'}
                        fieldColumns={2}
                        inputComponent={<input className="mt-2" checked={certificacionUnica} onChange={(e) => this.setState({ certificacionUnica: !certificacionUnica })} type="checkbox" name="certificacionUnica"></input>}
                    />
                </Fragment>
                }*/}
            </ParadigmaModal>
        );
    }
}

export default Avanzar;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento2/Avanzar.js